import React, { memo, useEffect, useState } from "react";
import SlideOutSidebar from "../../../../ui-components/slide-out-sidebar/slideOutSidebar";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "./billingReviewItemDetails.scss";
import { ShipmentWorkItemAccessorialsState } from "../../../../slices/shipment-reconciliation/ShipmentReconciliationState";
import { ReactComponent as PickupCancel } from "../../../../images/file_blue.svg";
import Table from "../../../../ui-components/table/table";
import { getBillingReviewAccessorialsColumns } from "./billingReviewAccessorialsColumns";
import { AccessorialApprovalStatus, ShipmentWorkItemAccessorial } from "../../../../app/data/shipment-reconciliation/models";
import OperationAccessorialApproval from "../accessorial-approval/billingAccessorialApproval";
import { getShipmentWorkItemAccessorials, shipmentWorkItemAccessorialsSelector } from "../../../../slices/shipment-reconciliation/shipmentWorkItemAccessorialsSlice";

interface BillingReviewItemDetailsProps {
  shipmentWorkItemId: number,
  probillNumber: number,
  terminalAirportCode: string,
  terminalName: string,
  terminalNumber: number,
  onClose: any
}

const BillingReviewItemDetails: React.FC<BillingReviewItemDetailsProps> = memo((props) => {
  const dispatch = useDispatch();
  const [selectedApprovalStatus, setSelectedApprovalStatus] = useState<AccessorialApprovalStatus | null>(null);
  const [selectedAccessorial, setSelectedAccessorial] = useState<ShipmentWorkItemAccessorial | null>(null);

  const shipmentWorkItemAccessorials: ShipmentWorkItemAccessorialsState = useSelector(
    shipmentWorkItemAccessorialsSelector
  );

  useEffect(() => {
    dispatch(getShipmentWorkItemAccessorials(
      props.shipmentWorkItemId,
      {isBillingReviewRequired: true},
      (error) => { toast.error(error) }
    ));
  }, [dispatch, props.shipmentWorkItemId]);


  const onAccessorialApproval = (approvalStatus: AccessorialApprovalStatus, accessorial: ShipmentWorkItemAccessorial) =>{
    setSelectedApprovalStatus(approvalStatus);
    setSelectedAccessorial(accessorial);
  }

  const resetApprovalSelection = () =>{
    setSelectedApprovalStatus(null);
    setSelectedAccessorial(null);
  }

  const onApprovalSucccess = () => {
    dispatch(getShipmentWorkItemAccessorials(
      props.shipmentWorkItemId,
      {isBillingReviewRequired: true},
      (error) => { toast.error(error) }
    ));
  }

  return (
    <SlideOutSidebar
      header={`Details for Probill # ${props.probillNumber}`}
      onClose={props.onClose}
      size="large"
      show={!!props.shipmentWorkItemId}
    ><div className="xgs-billing-review-item-details">
        <div className="content-box">
          <div className="header">
            <div className="icon-container"><PickupCancel /></div>
            <div className="title">Accessorials</div>
          </div>
          <div className="content">
            <div className="content__table-wrapper">
              <Table
                isLoading={shipmentWorkItemAccessorials.loading}
                columns={getBillingReviewAccessorialsColumns(onAccessorialApproval, props.terminalAirportCode, props.terminalName, props.terminalNumber)}
                data={shipmentWorkItemAccessorials.accessorials}
                cursorPointer={true}
                // rowHeight={100}
                noResultsText="No Accessorials available"
                onSelectedRowsChange={null}
                responsive={true}
              />
            </div>
          </div>
        </div>
      </div>
      { !!(selectedAccessorial && selectedAccessorial.id && selectedApprovalStatus) && <OperationAccessorialApproval 
            shipmentWorkItemId = {selectedAccessorial.shipmentWorkItemId}
            accessorialId={selectedAccessorial.id}
            accessorialName={selectedAccessorial.accessorialDefinition.name}
            accessorialRate={selectedAccessorial.accessorialDefinition.rate}
            approvalStatus={selectedApprovalStatus}
            onClose={resetApprovalSelection}
            onSuccess={onApprovalSucccess}
        /> 
      }
    </SlideOutSidebar>
  );
});

export default BillingReviewItemDetails;
